<template lang="html">
  <div class="container">
      <div class="row">
          <h1>Grupos de Requisição</h1>
          <hr>
          <router-link :to="{name: 'GroupDetail'}" type="button" class="btn btn-default">
              <span class="glyphicon glyphicon-plus"></span> Adicionar
          </router-link>
          <br><br>
          <div v-if="loading">
            <loader></loader>
          </div>
          <div v-else>
            <div class="col-sm-1">
              <b-form-select :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15}]" v-model="perPage" class="input-sm"></b-form-select>
            </div>
            <div class="col-sm-9"></div>
            <div class="col-sm-2">
              <b-form-input v-model="filter" placeholder="Digite para pesquisar" class="input-sm"></b-form-input>
            </div>
            <b-table :items="roleList" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" striped hover>
              <span slot="rolesList" slot-scope="item">
                  {{ item.value.join(', ') }}
              </span>
              <router-link slot="options" slot-scope="item"
                            :to="{name: 'GroupDetail', params: {id: item.item.objectId}}"
                            class="btn btn-primary btn-sm">
                <span class="glyphicon glyphicon-edit"></span> Editar
              </router-link>
            </b-table>
            <b-pagination size="sm" :total-rows="this.roleList.length" :per-page="perPage" v-model="currentPage"/>
          </div>
      </div>
    </div>
</template>

<script>
  import {
    Parse
  } from '../Global'

  import Loader from './util/Loader'
  import Multiselect from 'vue-multiselect'
  import { handleParseError } from './util/ErrorHandling'

  export default {
    components: {
      Loader,
      Multiselect
    },
    data () {
      return {
        roleList: [],
        loading: false,
        fields: {
          description: { label: 'Nome', sortable: true },
          rolesList: { label: 'Grupos Filhos', sortable: true },
          createdAtFmt: {label: 'Data de Criação', sortable: true},
          updatedAtFmt: {label: 'Última Atualização', sortable: true},
          options: {label: 'Opções'}
        },
        currentPage: 1,
        perPage: 5,
        filter: null
      }
    },
    mounted () {
      this.getRoles()
    },
    methods: {
      getRoles () {
        let self = this
        self.loading = true
        let query = new Parse.Query(Parse.Role)
        query.include('roles')
        query.ascending('description')
        query.limit(10000)
        query.find({
          success (results) {
            self.roleList = results.map(r => {
              let json = r.toJSON()
              if (json.createdAt) {
                let dtFormat = new Date(json.createdAt)
                json.createdAtFmt = dtFormat.toLocaleString('pt-BR')
              }
              if (json.updatedAt) {
                let dtFormat = new Date(json.updatedAt)
                json.updatedAtFmt = dtFormat.toLocaleString('pt-BR')
              }
              json.rolesList = []
              r.relation('roles').query().each(role => {
                json.rolesList.push(role.get('description'))
              })
              return json
            })
            self.loading = false
          },
          error (error) {
            handleParseError(self, error)
            self.loading = false
          }
        })
      }
    }
  }

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// GroupList.vue?4cfd0ac0